// Section 8 and 10: Toolmaker. 1.5 tools per productive season at 1 wood and 0.5 stone each;
// a workshop multiplies output by 1.5 (the workshop's modifier). 1% injury. Output goes first to
// restoring the durability of tools in use, then to new tools (the `makeTools` delta, applied by
// phases/shared/tools.ts). Constants: config.jobs.toolmaker.
import type { Config } from '../../config';
import { alwaysEligible } from '../../core/content-helpers';
import { defineJob, noModifiers } from '../../core/registry';
import type { Delta } from '../../core/types';

export function toolmaker(config: Config) {
  const c = config.jobs.toolmaker;

  return defineJob({
    id: 'toolmaker',
    label: 'Toolmaker',
    section: 'S8',
    heavy: false,
    output: { kind: 'stock', resource: 'tools' },
    baseYield: c.yield,
    toolFactor: null,
    toolWear: 0,
    risks: { injury: c.injury },
    riskIllness: null,
    requiresBuilding: null,
    minStrength: 0,
    modifierTargets: [],
    modifiers: noModifiers,
    produce(ctx, _worker, output) {
      const stocks = ctx.state.stocks;
      const made = Math.max(
        0,
        Math.min(output, stocks.wood.amount / c.woodPerTool, stocks.stone.amount / c.stonePerTool),
      );
      if (made <= 0) return [];
      const deltas: Delta[] = [
        { kind: 'stock', resource: 'wood', amount: -made * c.woodPerTool, flow: 'consumption' },
        { kind: 'stock', resource: 'stone', amount: -made * c.stonePerTool, flow: 'consumption' },
        { kind: 'makeTools', amount: made },
      ];
      return deltas;
    },
    eligible: alwaysEligible,
  });
}
